import { type Signal } from '@preact/signals'

import {
	Button,
	Input,
	Modal,
	Select,
	TextLink,
	Typography
} from 'components/UI'

import {
	memberEmailState,
	rolesState,
	rolSelectedState,
	setMemberEmail,
	setMemberRole
} from '../state'

interface Props {
	addMember: () => void
	closeAddMemberModal: () => void
	isModalOpen: Signal<boolean>
}

const AddMemberModal = ({
	addMember,
	closeAddMemberModal,
	isModalOpen
}: Props) => (
	<Modal
		className='space-y-10 p-10'
		isOpen={isModalOpen.value}
		onCloseModal={closeAddMemberModal}
	>
		<Typography color='text-product' text='Acquire Seat' variant='h2' />

		<div>
			<Input
				id='member-username'
				label='Email'
				name='userHandler'
				onInput={setMemberEmail}
				placeholder='Write the email of the member'
				value={memberEmailState}
			/>
			<div class='mt-4'>
				<Select
					description='Assign a Role'
					id='role'
					label='Role'
					onChange={setMemberRole}
					options={rolesState.value}
					value={rolSelectedState.value}
				/>
			</div>
		</div>

		<div class='flex justify-between'>
			<TextLink
				ariaLabel='Cancel'
				onClick={closeAddMemberModal}
				text='Cancel'
				variant='secondary'
			/>

			<Button onClick={addMember} text='Acquire Seat' />
		</div>
	</Modal>
)

export { AddMemberModal }
